var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRugby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9362 11.8308C20.8905 7.13156 14.3551 5.02779 7.12263 6.1108L6.28236 6.23528L6.15788 7.07554C5.2118 13.362 6.62469 19.0695 10.1413 23.1588C13.4775 27.0302 18.4693 29.1651 24.1955 29.1651C25.4155 29.1651 26.6852 29.0655 27.9549 28.8788L28.7952 28.7543L28.9197 27.9141C29.8657 21.6277 28.4529 15.9201 24.9362 11.8308ZM8.31144 8.27681C10.1974 8.05896 11.9962 8.11498 13.7078 8.36395L8.37991 13.6918C8.13094 11.9802 8.09982 10.1627 8.31144 8.27681ZM11.8841 21.665C10.5708 20.1401 9.61852 18.3351 8.9961 16.3371L16.3717 8.96147C19.0793 9.80796 21.4195 11.2769 23.1934 13.3308C24.5441 14.8993 25.5213 16.7666 26.1375 18.833L18.8863 26.0842C16.1041 25.2501 13.6953 23.7688 11.8841 21.665ZM26.7599 26.719C24.9486 26.9306 23.2121 26.8871 21.5627 26.663L26.7101 21.5156C26.9342 23.165 26.9653 24.9078 26.7599 26.719Z",
    fill: "#14171F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRugby);
export default __webpack_public_path__ + "static/media/rugby.3873d223d3f2c19e8dceef67a10d12f4.svg";
export { ForwardRef as ReactComponent };